import React, { Profiler, useCallback } from 'react';

const PerformanceWrapper = ({ id, children }) => {
  const onRenderCallback = useCallback((
    profilerId,
    phase,
    actualDuration,
    baseDuration,
    startTime,
    commitTime,
    interactions
  ) => {
    // Only log slow renders (> 16ms for 60fps)
    if (actualDuration > 16) {
      console.warn(`[Performance] ${profilerId} (${phase})`, {
        actualDuration: `${actualDuration.toFixed(2)}ms`,
        baseDuration: `${baseDuration.toFixed(2)}ms`,
        timestamp: new Date(commitTime).toISOString(),
        interactions: interactions?.size || 0
      });
    }
  }, []);

  return (
    <Profiler id={id} onRender={onRenderCallback}>
      {children}
    </Profiler>
  );
};

export default PerformanceWrapper;